import * as React from 'react'
import type { CalendarEvent, CalendarView } from '../../typings'
import { WeekGrid } from './WeekGrid'
import { MonthGrid } from './MonthGrid'
import { DayGrid } from './DayGrid'

type Props = {
  view: CalendarView
  /** Any day within the active range; each grid derives its own span from it. */
  cursor: Date
  /** Week start (Sunday, midnight) — used by the week grid. */
  weekStart: Date
  events: CalendarEvent[]
  /** Opens the day view on a date — target of the "+N more" affordances. */
  onShowDay?: (day: Date) => void
}

/**
 * Mounts EXACTLY ONE grid for the active view (LAYOUT-ARCHITECTURE.md §1) — the
 * others are removed from the DOM, never hidden. M2 ships all three views.
 */
export function CalendarGrid({
  view,
  cursor,
  weekStart,
  events,
  onShowDay,
}: Props) {
  if (view === 'month') {
    return <MonthGrid cursor={cursor} events={events} onShowDay={onShowDay} />
  }

  if (view === 'day') {
    return <DayGrid cursor={cursor} events={events} />
  }

  return (
    <WeekGrid weekStart={weekStart} events={events} onShowDay={onShowDay} />
  )
}
